import { motion } from 'framer-motion';
import { IconSparkles, IconUsers, IconTrendingUp, IconHeart } from '@tabler/icons-react';
import { Card } from '../components/ui/card';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-background bg-noise">
      <motion.section
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        className="py-12 sm:py-16 lg:py-24"
      >
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl lg:text-6xl text-center mb-6">О нас</h1>
          <p className="text-lg text-center text-[color:hsl(var(--foreground))]/70 max-w-3xl mx-auto mb-16">
            Сеть парикмахерских коворкингов РИО — это идеальное сочетание высокого сервиса, доступных цен и заботы о вашем времени.
          </p>

          {/* Миссия */}
          <div className="mb-16">
            <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8 sm:p-12">
              <IconSparkles size={48} className="text-[color:hsl(var(--brand-orange))] mb-6" />
              <h2 className="font-['Playfair_Display'] text-3xl mb-4">Наша миссия</h2>
              <p className="text-base text-[color:hsl(var(--foreground))]/80 leading-relaxed">
                Мы создали место, куда удобно зайти всей семьей — быстро, без записи и с гарантией качества. 
                Наши парикмахерские работают по принципу "живой очереди": вы приходите в удобное время, 
                получаете качественную услугу и идете дальше по своим делам.
              </p>
            </Card>
          </div>

          {/* Преимущества */}
          <h2 className="font-['Playfair_Display'] text-3xl text-center mb-10">Почему выбирают РИО</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8 text-center">
              <IconUsers size={40} className="text-[color:hsl(var(--brand-orange))] mx-auto mb-4" />
              <h3 className="font-medium text-xl mb-3">Семейный формат</h3>
              <p className="text-sm text-[color:hsl(var(--foreground))]/70">
                Стрижки для всей семьи в одном месте. Копите бонусы быстрее.
              </p>
            </Card>
            <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8 text-center">
              <IconTrendingUp size={40} className="text-[color:hsl(var(--brand-orange))] mx-auto mb-4" />
              <h3 className="font-medium text-xl mb-3">Без записи</h3>
              <p className="text-sm text-[color:hsl(var(--foreground))]/70">
                Приходите когда удобно. Живая очередь — это быстро и просто.
              </p>
            </Card>
            <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8 text-center">
              <IconHeart size={40} className="text-[color:hsl(var(--brand-orange))] mx-auto mb-4" />
              <h3 className="font-medium text-xl mb-3">Каждая 6-я бесплатно</h3>
              <p className="text-sm text-[color:hsl(var(--foreground))]/70">
                Накопительная система: каждая шестая стрижка в подарок!
              </p>
            </Card>
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default AboutPage;